// extracted by mini-css-extract-plugin
export var content = "_ne-1";
export var divider = "_ne-0";